import Skeleton from '@/common/components/Skeleton'

const InfoFieldSkeleton = () => (
  <div className="flex flex-col gap-1 p-2 flex-1 bg-white-100 rounded">
    <Skeleton height={12} width="40%" />

    <Skeleton height={16} width="70%" />
  </div>
)

const InfoFieldRow = ({ count = 3 }: { count?: number }) => (
  <div className="flex items-center gap-1">
    {Array.from({ length: count }).map((_, index) => (
      <InfoFieldSkeleton key={index} />
    ))}
  </div>
)

const AccordionSkeleton = ({ rows = 1, withChart }: { rows?: number; withChart?: boolean }) => (
  <div className="w-full p-4 rounded-sm bg-white-100">
    <div className="py-4">
      <Skeleton height={20} width={180} />
    </div>

    <div className="flex flex-col gap-1">
      {Array.from({ length: rows }).map((_, index) => (
        <InfoFieldRow key={index} />
      ))}

      {withChart && (
        <div className="mt-3">
          <Skeleton className="min-h-[280px] mt-1" />
        </div>
      )}
    </div>
  </div>
)

export const FipeDataSkeleton = () => {
  return (
    <div className="flex w-full flex-col flex-1 overflow-auto max-h-[calc(100vh-128px)] gap-y-6 bg-[#FFFFFF0D] rounded-sm p-6">
      <AccordionSkeleton rows={1} withChart />

      <AccordionSkeleton rows={2} />

      <AccordionSkeleton rows={10} />

      <AccordionSkeleton rows={2} />

      <AccordionSkeleton rows={2} />

      <AccordionSkeleton rows={1} />

      <AccordionSkeleton rows={2} />

      <AccordionSkeleton rows={1} />
    </div>
  )
}
